import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';
import { articleImages } from '@/mocks/articleImages';

const relatedImages = [
  'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20editorial%20photograph%20with%20soft%20coral%20tones%2C%20clean%20minimal%20composition%2C%20gentle%20natural%20lighting%2C%20modern%20aesthetic%2C%20subtle%20textures%2C%20professional%20photography%20style%2C%20elegant%20mood%2C%20warm%20neutral%20background%2C%20no%20text&width=600&height=375&seq=rel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20warm%20ambient%20photograph%20with%20golden%20hour%20lighting%2C%20clean%20modern%20composition%2C%20elegant%20minimal%20style%2C%20gentle%20peach%20and%20cream%20tones%2C%20professional%20editorial%20photography%2C%20atmospheric%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=375&seq=rel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20still%20life%20with%20soft%20natural%20lighting%2C%20neutral%20textures%2C%20minimal%20modern%20aesthetic%2C%20clean%20composition%2C%20elegant%20shadows%2C%20professional%20photography%2C%20atmospheric%20mood%2C%20no%20text&width=600&height=375&seq=rel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20warm%20abstract%20photograph%20with%20coral%20and%20amber%20gradients%2C%20soft%20flowing%20forms%2C%20minimal%20modern%20composition%2C%20gentle%20light%20play%2C%20atmospheric%20texture%2C%20professional%20fine%20art%20style%2C%20clean%20background%2C%20no%20text&width=600&height=375&seq=rel-04&orientation=landscape',
];

interface RelatedArticlesProps {
  articles: Article[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  if (articles.length === 0) return null;

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
            Related Reading
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            相关<span className="text-secondary-500">推荐</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group cursor-pointer"
            >
              <article className="bg-background-50 rounded-2xl overflow-hidden h-full flex flex-col">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={relatedImages[index] || relatedImages[0]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`今日看料 - ${article.title}`}
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2 py-0.5 rounded">
                      {article.categoryName}
                    </span>
                    {article.isHot && (
                      <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded flex items-center gap-0.5">
                        <i className="ri-fire-line text-[10px]"></i>热
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors flex-1">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500 mt-3 pt-3 border-t border-background-200/70">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount > 10000
                        ? `${(article.viewCount / 10000).toFixed(1)}万阅读`
                        : `${article.viewCount}阅读`}
                    </span>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}